<template>
  <VLayout
    row
    class="base_input_checkbox ma-0"
    align-items-center
    data-testid="base-input-checkbox"
  >
    <VCol v-show="label" cols="8" data-testid="checkbox-label-col">
      <label :for="id" data-testid="checkbox-label">{{ label }}</label>
    </VCol>
    <VCol cols="4" class="pa-0" data-testid="checkbox-switch-col">
      <SocioSwitch
        :id="id"
        v-model="model"
        class="switch__small ma-0 ml-3"
        density="compact"
        :label="yesNo"
        data-testid="checkbox-switch"
      />
    </VCol>
  </VLayout>
</template>

<script setup>
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";

  defineProps({
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  });

  const model = defineModel({ type: Boolean, default: false });

  const { t } = useI18n();

  const yesNo = computed(() => (model.value ? t("Yes") : t("No")));
</script>

<style lang="scss" scoped>
  .base_input_checkbox {
    align-items: center;
    label {
      margin-bottom: 0 !important;
    }
    .switch_label {
      margin-bottom: 0;
    }
    .switch__small {
      margin: 10px;
    }

    :deep(.v-switch) {
      label {
        word-break: initial;
      }
    }
  }
</style>

<i18n>
{
  "en": {
    "Yes": "Yes",
    "No": "No"
  },
  "fr": {
    "Yes": "Oui",
    "No": "Non"
  },
  "nl": {
    "Yes": "Ja",
    "No": "Nee"
  }
}
</i18n>
